import { onyxGreenColor, grayColor } from "assets/jss/default/theme";

export const header = {
  header: {
    fontSize: 18,
    color: grayColor[6]
  }
};

const FILTER_WIDTH_MAPPING = {
  Priority: 105,
  Status: 100,
  Site: 30,
  Machine: 120,
  Component: 140,
  "Failure Mode": 150,
  "Machine Status": 170,
  Assignee: 120,
  Diagnostics: 140,
  Inspection: 130,
  "Major Component Failure": 250,
  "Warranty Coverage": 200
};

const filterDropDownsStyle = {
  minWidth: ({ title }) => FILTER_WIDTH_MAPPING[title] ?? 150,
  paddingRight: 8,
  display: "inline-flex",
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
    color: onyxGreenColor
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: onyxGreenColor
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: onyxGreenColor
  },
  "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: onyxGreenColor
  }
};

export const checkboxStyles = {
  checkbox: {
    "&.MuiCheckbox-root": {
      color: onyxGreenColor,
      "&.Mui-disabled": {
        color: "rgba(0, 0, 0, 0.26)"
      }
    },
    "&.MuiCheckbox-colorSecondary": {
      "&.Mui-checked": {
        color: onyxGreenColor
      }
    }
  }
};

export const commonTableStyles = {
  headerCell: {
    padding: [[10, 0, 10, 10]],
    fontWeight: "bold",
    textAlign: "left",
    verticalAlign: "top",
    backgroundColor: "#FFFFFF"
  },
  tableRow: {
    height: 60,
    "&:nth-of-type(odd)": {
      backgroundColor: "#F8F8F8"
    },
    "&:nth-of-type(even)": {
      backgroundColor: "#F0F0F0"
    },
    "&:hover": {
      backgroundColor: "#DCDCDC",
      cursor: "pointer"
    }
  },
  tableRowNoPointer: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#F8F8F8"
    },
    "&:nth-of-type(even)": {
      backgroundColor: "#F0F0F0"
    },
    "&:hover": {
      backgroundColor: "#DCDCDC"
    }
  },
  tableRowHover: {
    "&:hover": {
      backgroundColor: "rgba(76, 175, 80, 0.5)",
      cursor: "pointer"
    }
  },
  tableSelected: {
    backgroundColor: "rgba(76, 175, 80, 0.3)"
  },
  tableCell: {
    width: "1%",
    padding: [[10, 0, 10, 10]]
  },
  paperTopMargin: {
    marginTop: 10
  },
  buttonLeftMargin: {
    marginLeft: 10
  },
  DDTButtonsContainer: {
    padding: [[5, 0, 10, 0]],
    textAlign: "end"
  },
  ...header
};

export const commonFilterStyles = theme => ({
  ...checkboxStyles,
  filtersPaper: {
    padding: [[16, 16, 5, 16]],
    marginBottom: 20
  },
  clearFiltersButton: {
    margin: theme.spacing(0.5),
    [theme.breakpoints.up("lg")]: {
      float: "right"
    }
  },
  filterDropdownsContainer: {
    marginTop: 5,
    width: "100%"
  },
  filterOptionsButton: {
    float: "right",
    minHeight: 38,
    marginLeft: 10
  },
  filterDropDowns: {
    ...filterDropDownsStyle,
    margin: theme.spacing(0.5)
  },
  autoCompleteDropDowns: {
    ...filterDropDownsStyle,
    margin: theme.spacing(0.5),
    "& label.Mui-focused": {
      transform: "translate(14px, -6px) scale(0.75)",
      backgroundColor: "white"
    }
  },
  ...header
});

export const selectedFilteringOptionsStyles = {
  chipArray: {
    display: "flex",
    justifyContent: "left",
    flexWrap: "wrap",
    listStyle: "none",
    paddingLeft: 5,
    marginTop: 20,
    backgroundColor: "#f2f2f2",
    borderRadius: 20,
    minHeight: 42
  },
  chip: {
    margin: 5,
    backgroundColor: "#e0e0e0"
  }
};
